module.exports = __webpack_public_path__ + "img/img4.2da3779e.jpg";